/* eslint-disable */
import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { Form, Errors } from 'forms/rrf';
import { find } from 'lodash';
import SearchableSelect from '../../../components/common/form/elements/searchable-select';
import ArrowButton from '../../../components/common/button-arrow';
import NumberOfPacksSold from '../../../components/submissions/postcode-plan/number-of-packs-sold';
import { getFilteredPostcodePlanObjectives } from '../../../actions/postcode-plan-objectives';

class PostcodePlanForm extends Component {
  state = {
    stores: []
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { meta } = nextProps;

    if (this.state.stores.length === 0) {
      this.setState({
        stores: meta.outlets
      });
    }
  }

  UNSAFE_componentWillMount() {
    this.setState({ stores: this.props.meta.outlets });
  }

  componentDidUpdate(prevProps) {
    const { formData: { outlet_id }, dispatch } = this.props;

    if (outlet_id !== prevProps.formData.outlet_id) {
      dispatch(getFilteredPostcodePlanObjectives(outlet_id));
    }
  }

  handlePostcodeplanChange = (e) => {
    const postcodeplan_objective = find(this.props.meta.postcodeplan_objectives, { value: e });
    this.setState({ stores: postcodeplan_objective.outlets });
  };

  findPostcodeplanObjective = (postcodeplanObjectiveId) => {
    const { filteredPostcodePlanObjectives } = this.props;
    const postcodeplanObjective = filteredPostcodePlanObjectives.find(postcodeplanObjective =>
      postcodeplanObjective.value === postcodeplanObjectiveId
    );

    if (postcodeplanObjective) {
      return postcodeplanObjective;
    }
  };

  render() {
    const { model, formData, formValid, meta, onSubmit } = this.props;
    const { outlet_id, postcodeplan_objective_id } = formData;
    const isOutletAndPostcodeSelected = outlet_id !== '' && postcodeplan_objective_id !== '';
    const postcodeplanObjective = this.findPostcodeplanObjective(postcodeplan_objective_id);

    return (
      <div className="mg-bottom-60 mg-top-10">
        <div className="container-fluid padding-flush">
          <Form
            model={model}
            onSubmit={onSubmit}
            className="sell-it-submissions-tabs-epos-form"
            validators={
              {
                '': vals => (
                  vals.brands && !Object.values(vals.brands).every(value => +value === 0)
                )
              }
            }
          >
            <Row>
              <Col md={6} xs={12}>
                <Row>
                  <Col md={12}>
                    <Errors model={model} className="errors" />
                  </Col>
                  <Col md={12}>
                    <SearchableSelect
                      label='Outlet Name'
                      model={`${model}.outlet_id`}
                      options={this.state.stores}
                      value={outlet_id}
                      required
                    />
                  </Col>
                  <Col md={12}>
                    <SearchableSelect
                      label='Postcode Plan Objective'
                      model={`${model}.postcodeplan_objective_id`}
                      options={meta.postcodeplan_objectives}
                      value={postcodeplan_objective_id}
                      onChange={this.handlePostcodeplanChange}
                      required
                    />
                  </Col>
                </Row>
                {isOutletAndPostcodeSelected && postcodeplanObjective ?
                  <div>
                    <NumberOfPacksSold
                      model={model}
                      evidenceType={find(postcodeplanObjective.outlets, { value: outlet_id } ).evidence_type}
                      brands={postcodeplanObjective.brands}
                    />
                    <Row>
                      <Col md={12} className="sell-it-submissions-tabs-epos-form-buttons">
                        <ArrowButton className="float-end" arrow={false} disabled={!formValid} submit>
                          Submit
                        </ArrowButton>
                      </Col>
                    </Row>
                  </div> :
                  <Row>
                    <Col md={12} className="warning">
                      Please select an outlet and Postcode Plan Objective
                    </Col>
                  </Row>
                }
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.postcodePlanObjective,
  formValid: state.deep.forms.postcodePlanObjective.$form.valid,
  filteredPostcodePlanObjectives: state.postcodePlanObjectives.filteredPostcodePlanObjectives
});

export default connect(mapStateToProps)(PostcodePlanForm);
